import type { ClientOptions as AblyClientOptions, ErrorInfo as AblyErrorInfo } from "ably";
import type { RealtimeTransportOptions } from "./client";

import type { SessionRealtimeChannelsModel } from "@/models";

interface CreateRealtimeOptionsParams {
  channelResolver: () => string | string[] | undefined;
  clientId?: string;
  tokenProvider?: () => Promise<any>;
  channelsConfig?: SessionRealtimeChannelsModel;
}

export function createRealtimeTransportOptions(params: CreateRealtimeOptionsParams): RealtimeTransportOptions | undefined {
  const resolvedChannels = params.channelResolver();
  if (!resolvedChannels || (Array.isArray(resolvedChannels) && !resolvedChannels.length)) {
    return undefined;
  }
  if (!params.tokenProvider) {
    return undefined;
  }
  const clientOptions: AblyClientOptions = {
    clientId: params.clientId,
    authCallback: (_data: any, callback: any) => {
      params
        .tokenProvider!()
        .then((token) => callback(null, token))
        .catch((error) => {
          const baseMessage = error instanceof Error ? error.message : String(error);
          const errorInfo: AblyErrorInfo = {
            message: baseMessage,
            code: 0,
            statusCode: 500,
            name: "RealtimeAuthError",
          };
          callback(errorInfo, undefined as any);
        });
    },
  };

  const channelResolver = () => {
    const channel = params.channelResolver();
    if (!channel || (Array.isArray(channel) && !channel.length)) {
      throw new Error("Realtime channel resolver returned undefined.");
    }
    return channel;
  };

  return {
    channelName: channelResolver,
    clientOptions,
    channelsConfig: params.channelsConfig,
  };
}
